// The words on an agent run's download button, from the file the server says it gives
// (`download_format`). Shared by the dossier and the strategy.

export type AgentDownloadFormat = 'docx' | 'pdf';

export interface AgentDownloadLabel {
  label: string;
  title: string;
}

const LABELS: Record<AgentDownloadFormat, AgentDownloadLabel> = {
  docx: { label: 'Download Word', title: 'Download as Word' },
  pdf: { label: 'Download PDF', title: 'Download as PDF' },
};

/** A response without a format (saved before the server sent one) keeps the PDF label. */
export function agentDownloadLabel(format: AgentDownloadFormat | null | undefined): AgentDownloadLabel {
  return LABELS[format ?? 'pdf'];
}
